<template>
</template>

<script>
import { pathToRegex } from '../../utils';

function addAgentLauncherWidget(token, options = {}) {
  const tokenId = `story-${token}`;

  let element = document.getElementById(tokenId);

  if (!element) {
    element = document.createElement("showpilot-agent-launcher")
    element.setAttribute("token", token)
    element.setAttribute("id", tokenId)
    document.body.appendChild(element)
  }

  return {
    element: element,
    show(){
        setTimeout(() => {
            element.__vue_custom_element__.$children[0].showModal({
                onClose: options.onClose
            })
        }, 10);
    }
  };
}

export default {
    props: ['ptkn'],
    data() {
        return {
            paths: [],
            currentExperience: null,
            cleanups: [],
            shownExperiences: new Set(),
            isExperienceActive: false
        }
    },
    created() {
        if(this.ptkn) {
            this.patchHistoryAPI();
            this.getPaths();
            this.setupNavigationListener();
        }
    },
    beforeDestroy() {
        this.cleanup();
    },
    methods: {
        patchHistoryAPI() {
            const originalPushState = history.pushState;
            const originalReplaceState = history.replaceState;
            
            history.pushState = function() {
                originalPushState.apply(this, arguments);
                window.dispatchEvent(new Event('pushstate'));
            };
            
            history.replaceState = function() {
                originalReplaceState.apply(this, arguments);
                window.dispatchEvent(new Event('replacestate'));
            };
        },
        setupNavigationListener() {
            const handleNavigation = () => {
                console.log("__showpilot__navigated__");
                this.cleanup();
                this.getCurrentExperience();
            };
            
            window.addEventListener('popstate', handleNavigation);
            window.addEventListener('pushstate', handleNavigation);
            window.addEventListener('replacestate', handleNavigation);
        },
        getPaths() {
            this.axios.post(`frontend/targeting`, {
                url: window.location.href,
                ptkn: this.ptkn
            })
            .then(response => {
                const { data } = response.data;
                this.paths = data;
                this.convertPathsToRegex();
                this.getCurrentExperience();
            }).catch((error) => {
                console.log(error);
            })
        },
        convertPathsToRegex() {
            this.paths.forEach(path => {
                path.regex = pathToRegex(path.path);
            });
        },
        getUrlParams() {
            return new URLSearchParams(window.location.search);
        },
        getCurrentExperience() {
            const currentPath = window.location.pathname;
            this.isExperienceActive = false;

            const matchingPath = this.paths.find(path => {
                return path.regex.test(currentPath);
            });

            if (matchingPath?.triggers?.length) {
                const urlParams = this.getUrlParams();

                const utmTrigger = matchingPath.triggers.find(trigger => {
                    if (trigger.type === 'utm') {
                        const paramValue = urlParams.get(trigger.meta.property);
                        return paramValue === trigger.meta.value;
                    }
                    return false;
                });

                if (utmTrigger && !this.isExperienceShown("utm", utmTrigger.experience)) {
                    this.currentExperience = utmTrigger.experience;
                    this.showExperience(utmTrigger.experience, "utm");
                    this.setShownExperience("utm", utmTrigger.experience);
                    this.isExperienceActive = true;
                } else {
                    const pageLoadTrigger = matchingPath.triggers.find(trigger => 
                        trigger.type === 'page_load' && trigger.experience
                    );
                    
                    if (pageLoadTrigger && !this.isExperienceShown("page_load", pageLoadTrigger.experience)) {
                        this.currentExperience = pageLoadTrigger.experience;
                        this.showExperience(pageLoadTrigger.experience);
                        this.setShownExperience("page_load", pageLoadTrigger.experience);
                        this.isExperienceActive = true;
                    }
                }

                const elementOnPageTrigger = matchingPath.triggers.filter(trigger => 
                    trigger.type === 'element' && trigger.experience
                );

                if (elementOnPageTrigger.length) {
                    this.setupElements(elementOnPageTrigger);
                }

                const timeOnPageTrigger = matchingPath.triggers.find(trigger => 
                    trigger.type === 'time_on_page' && trigger.experience
                );

                if (timeOnPageTrigger && !this.isExperienceShown("time_on_page", timeOnPageTrigger.experience)) {
                    this.setupTimeOnPage(timeOnPageTrigger);
                }

                const scrollDepthTrigger = matchingPath.triggers.find(trigger => 
                    trigger.type === 'scroll_depth' && trigger.experience
                );

                if (scrollDepthTrigger && !this.isExperienceShown("scroll_depth", scrollDepthTrigger.experience)) {
                    this.setupScrollDepth(scrollDepthTrigger);
                }

                const exitIntentTrigger = matchingPath.triggers.find(trigger => 
                    trigger.type === 'exit_intent' && trigger.experience
                );

                if (exitIntentTrigger && !this.isExperienceShown("exit_intent", exitIntentTrigger.experience)) {
                    this.setupExitIntent(exitIntentTrigger);
                }
            }
            return null;
        },
        setupElements(triggers) {
            triggers.forEach(trigger => {
                const element = document.querySelector(trigger.meta.element_selector);
                
                if (trigger.meta.element_trigger_type === 'click') {
                    const showExperience = () => {
                        this.showExperience(trigger.experience);
                    };

                    element.addEventListener('click', showExperience);

                    this.cleanups.push(() => element.removeEventListener('click', showExperience));
                }
            });
        },
        showExperience(experience) {
            if(experience.type === "demo_center") {
                const agentLauncher = addAgentLauncherWidget(experience.public_id, {
                    onClose: () => {
                        this.isExperienceActive = false;
                    }
                });

                agentLauncher.show();
            }
        },
        setShownExperience(type, experience) {
            this.shownExperiences.add(`${type}_${experience.public_id}`);
        },
        isExperienceShown(type, experience) {
            return this.shownExperiences.has(`${type}_${experience.public_id}`);
        },
        cleanup() {
            this.cleanups.forEach(cleanup => cleanup());
            this.cleanups = [];
        },
        setupTimeOnPage(trigger) {
            const timer = setTimeout(() => {
                if (!this.isExperienceActive && !this.isExperienceShown("time_on_page", trigger.experience)) {
                    this.showExperience(trigger.experience);
                    this.setShownExperience("time_on_page", trigger.experience);
                    this.isExperienceActive = true;
                }
            }, parseInt(trigger.meta.duration) * 1000);

            this.cleanups.push(() => clearTimeout(timer));
        },
        setupScrollDepth(trigger) {
            const handleScroll = () => {
                const scrollPercent = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
                
                if (scrollPercent >= trigger.meta.percentage &&  !this.isExperienceActive && !this.isExperienceShown("scroll_depth", trigger.experience)) {
                    this.showExperience(trigger.experience);
                    this.setShownExperience("scroll_depth", trigger.experience);
                    this.isExperienceActive = true;
                    window.removeEventListener('scroll', handleScroll);
                }
            };

            window.addEventListener('scroll', handleScroll);
            this.cleanups.push(() => window.removeEventListener('scroll', handleScroll));
        },
        setupExitIntent(trigger) {
            let isExitIntentShown = false;

            const handleExitIntent = (e) => {
                if (e.clientY <= 20 && !isExitIntentShown && !this.isExperienceActive && !this.isExperienceShown("exit_intent", trigger.experience)) {
                    isExitIntentShown = true;
                    this.showExperience(trigger.experience);
                    this.setShownExperience("exit_intent", trigger.experience);
                    this.isExperienceActive = true;

                    document.removeEventListener('mousemove', handleExitIntent);
                }
            };

            document.addEventListener('mousemove', handleExitIntent);
            
            this.cleanups.push(() => document.removeEventListener('mousemove', handleExitIntent));
        },
    },
}
</script>

